export const isDarkModeActive = window.matchMedia(
  '(prefers-color-scheme: dark)',
).matches;
